// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddNetwork_container__VdEC\\+ {
  background-color: rgba(0, 0, 0, 0.2);
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 200000;
}
.AddNetwork_container__VdEC\\+::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.AddNetwork_container__VdEC\\+::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.8);
}
.AddNetwork_container__VdEC\\+::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: hsl(0, 0%, 90%);
  box-shadow: inset 0 0 1px 1px #616161;
}
.AddNetwork_container__VdEC\\+::-webkit-scrollbar-thumb:hover {
  background-color: hsl(0, 0%, 85%);
  background-color: hsl(0, 0%, 80%);
}
@media screen and (max-width: 600px) {
  .AddNetwork_container__VdEC\\+ {
    padding: 0;
    bottom: 47px;
  }
}
@media screen and (min-width: 600px) {
  .AddNetwork_container__VdEC\\+ {
    padding: 47px;
    left: 80px;
    overflow: scroll;
  }
}
.AddNetwork_container__VdEC\\+ .AddNetwork_image__HPfxO {
  position: relative;
  margin: 4px;
}
.AddNetwork_container__VdEC\\+ .AddNetwork_image__HPfxO button {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 10px;
  right: -10px;
  height: 30px;
  width: 30px;
  border: none;
  background-color: var(--accent-color);
  border-radius: 20px;
}
.AddNetwork_container__VdEC\\+ .AddNetwork_image__HPfxO button svg {
  width: 15px;
  height: 15px;
  fill: white;
}
.AddNetwork_container__VdEC\\+ .AddNetwork_image__HPfxO button:hover {
  background-color: var(--accent-color-dark);
}
.AddNetwork_container__VdEC\\+ .AddNetwork_image__HPfxO button:hover svg {
  fill: #eee;
}
.AddNetwork_container__VdEC\\+ .AddNetwork_image__HPfxO button:active {
  background-color: var(--accent-color-x-dark);
}
.AddNetwork_container__VdEC\\+ .AddNetwork_image__HPfxO button:active svg {
  fill: #ddd;
}
.AddNetwork_container__VdEC\\+ .AddNetwork_image__HPfxO button:disabled {
  background-color: grey;
}
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB {
  background-color: white;
  padding: 30px;
  box-shadow: var(--shadow);
  border-radius: 5px;
  margin: auto;
  width: 40rem;
  height: -moz-fit-content;
  height: fit-content;
}
@media screen and (max-width: 600px) {
  .AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB {
    width: 100%;
    padding: 20px;
    overflow-y: scroll;
    max-height: 100%;
    border-radius: 0;
  }
}
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e {
  position: relative;
}
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_heading__QSt6Z {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_heading__QSt6Z h3 {
  margin: 0;
}
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_errors__963Zr {
  color: red;
  text-align: center;
}
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_date-input-row__yoB8n,
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_place-input-row__4OGTV {
  margin-bottom: 5px;
}
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_date-input-row__yoB8n > *,
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_place-input-row__4OGTV > * {
  margin: 5px;
}
@media screen and (max-width: 350px) {
  .AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_date-input-row__yoB8n {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
}
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_place-input-row__4OGTV {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_place-input-row__4OGTV .AddNetwork_place-input-container__hSeXd {
  max-width: calc(50% - 30px);
}
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_place-input-row__4OGTV .AddNetwork_place-input-container__hSeXd .AddNetwork_place-input__LNh5M {
  background-color: white;
  width: 220px;
}
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_text-details__\\+Shmo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 7px;
}
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_text-details__\\+Shmo input,
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_text-details__\\+Shmo textarea {
  margin: 3px 0;
  border: 1px solid #d2d2d2;
  border-radius: 4px;
  padding: 5px 10px;
  width: 100%;
}
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_text-details__\\+Shmo input,
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_text-details__\\+Shmo textarea,
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_place-input-row__4OGTV .AddNetwork_place-input-container__hSeXd .AddNetwork_place-input__LNh5M {
  outline: none;
  box-shadow: 0 0 0 0 var(--accent-color-02-opacity);
}
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_text-details__\\+Shmo input:focus,
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_text-details__\\+Shmo textarea:focus,
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_place-input-row__4OGTV .AddNetwork_place-input-container__hSeXd .AddNetwork_place-input__LNh5M:focus {
  border-color: var(--accent-color-light);
  box-shadow: 0 0 0 3px var(--accent-color-02-opacity);
}
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_privacy-level__--IhF {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px 0;
}
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_inputs__gGR3e .AddNetwork_privacy-level__--IhF > * {
  margin-right: 10px;
}
.AddNetwork_container__VdEC\\+ .AddNetwork_add-flight-plan__\\+oSFB .AddNetwork_button-container__-9w4A {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Components/NetworkGroups/AddNetwork.module.scss"],"names":[],"mappings":"AAAA;EACC,oCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;AACD;AACC;EACC,WAAA;EACA,YAAA;AACF;AAEC;EACC,4CAAA;AAAF;AAGC;EACC,kBAAA;EACA,iCAAA;EACA,qCAAA;AADF;AAIC;EACC,iCAAA;EAIA,iCAAA;AANF;AASC;EAhCD;IAiCE,UAAA;IACA,YAAA;EAHA;AACF;AAKC;EArCD;IAsCE,aAAA;IACA,UAAA;IACA,gBAAA;EAFA;AACF;AAIC;EACC,kBAAA;EACA,WAAA;AAFF;AAIE;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,mBAAA;AAFH;AAIG;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAFJ;AAKG;EACC,0CAAA;AAHJ;AAKI;EACC,UAAA;AAHL;AAOG;EACC,4CAAA;AALJ;AAOI;EACC,UAAA;AALL;AASG;EACC,sBAAA;AAPJ;AAYC;EACC,uBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,wBAAA;EAAA,mBAAA;AAVF;AAYE;EATD;IAUE,WAAA;IACA,aAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA;EATD;AACF;AAWE;EACC,kBAAA;AATH;AAWG;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AATJ;AAWI;EACC,SAAA;AATL;AAaG;EACC,UAAA;EACA,kBAAA;AAXJ;AAcG;;EAEC,kBAAA;AAZJ;AAcI;;EACC,WAAA;AAXL;AAgBI;EADD;IAEE,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;EAbH;AACF;AAgBG;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAdJ;AAgBI;EACC,2BAAA;AAdL;AAgBK;EACC,uBAAA;EACA,YAAA;AAdN;AAmBG;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAjBJ;AAmBI;;EAEC,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AAjBL;AAqBG;;;EAGC,aAAA;EACA,kDAAA;AAnBJ;AAqBI;;;EACC,uCAAA;EACA,oDAAA;AAjBL;AAqBG;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AAnBJ;AAqBI;EACC,kBAAA;AAnBL;AAwBE;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAtBH","sourcesContent":[".container {\n\tbackground-color: #0003;\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 200000;\n\n\t&::-webkit-scrollbar {\n\t\twidth: 10px;\n\t\theight: 10px;\n\t}\n\n\t&::-webkit-scrollbar-track {\n\t\tbox-shadow: inset 0 0 6px rgba(0, 0, 0, 0.8);\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tborder-radius: 5px;\n\t\tbackground-color: hsl(0, 0%, 90%);\n\t\tbox-shadow: inset 0 0 1px 1px #616161;\n\t}\n\n\t&::-webkit-scrollbar-thumb:hover {\n\t\tbackground-color: hsl(0, 0%, 85%);\n\t}\n\n\t&::-webkit-scrollbar-thumb:hover {\n\t\tbackground-color: hsl(0, 0%, 80%);\n\t}\n\n\t@media screen and (max-width: 600px) {\n\t\tpadding: 0;\n\t\tbottom: 47px;\n\t}\n\n\t@media screen and (min-width: 600px) {\n\t\tpadding: 47px;\n\t\tleft: 80px;\n\t\toverflow: scroll;\n\t}\n\n\t.image {\n\t\tposition: relative;\n\t\tmargin: 4px;\n\n\t\tbutton {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tposition: absolute;\n\t\t\ttop: 10px;\n\t\t\tright: -10px;\n\t\t\theight: 30px;\n\t\t\twidth: 30px;\n\t\t\tborder: none;\n\t\t\tbackground-color: var(--accent-color);\n\t\t\tborder-radius: 20px;\n\n\t\t\tsvg {\n\t\t\t\twidth: 15px;\n\t\t\t\theight: 15px;\n\t\t\t\tfill: white;\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--accent-color-dark);\n\n\t\t\t\tsvg {\n\t\t\t\t\tfill: #eee;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&:active {\n\t\t\t\tbackground-color: var(--accent-color-x-dark);\n\n\t\t\t\tsvg {\n\t\t\t\t\tfill: #ddd;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&:disabled {\n\t\t\t\tbackground-color: grey;\n\t\t\t}\n\t\t}\n\t}\n\n\t.add-flight-plan {\n\t\tbackground-color: white;\n\t\tpadding: 30px;\n\t\tbox-shadow: var(--shadow);\n\t\tborder-radius: 5px;\n\t\tmargin: auto;\n\t\twidth: 40rem;\n\t\theight: fit-content;\n\n\t\t@media screen and (max-width: 600px) {\n\t\t\twidth: 100%;\n\t\t\tpadding: 20px;\n\t\t\toverflow-y: scroll;\n\t\t\tmax-height: 100%;\n\t\t\tborder-radius: 0;\n\t\t}\n\n\t\t.inputs {\n\t\t\tposition: relative;\n\n\t\t\t.heading {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: row;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tmargin-bottom: 20px;\n\n\t\t\t\th3 {\n\t\t\t\t\tmargin: 0;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.errors {\n\t\t\t\tcolor: red;\n\t\t\t\ttext-align: center;\n\t\t\t}\n\n\t\t\t.date-input-row,\n\t\t\t.place-input-row {\n\t\t\t\tmargin-bottom: 5px;\n\n\t\t\t\t>* {\n\t\t\t\t\tmargin: 5px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.date-input-row {\n\t\t\t\t@media screen and (max-width: 350px) {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: row;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tflex-wrap: wrap;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.place-input-row {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: row;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\tflex-wrap: wrap;\n\n\t\t\t\t.place-input-container {\n\t\t\t\t\tmax-width: calc(50% - 30px);\n\n\t\t\t\t\t.place-input {\n\t\t\t\t\t\tbackground-color: white;\n\t\t\t\t\t\twidth: 220px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.text-details {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\tpadding: 0 7px;\n\n\t\t\t\tinput,\n\t\t\t\ttextarea {\n\t\t\t\t\tmargin: 3px 0;\n\t\t\t\t\tborder: 1px solid #d2d2d2;\n\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\tpadding: 5px 10px;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.text-details input,\n\t\t\t.text-details textarea,\n\t\t\t.place-input-row .place-input-container .place-input {\n\t\t\t\toutline: none;\n\t\t\t\tbox-shadow: 0 0 0 0 var(--accent-color-02-opacity);\n\n\t\t\t\t&:focus {\n\t\t\t\t\tborder-color: var(--accent-color-light);\n\t\t\t\t\tbox-shadow: 0 0 0 3px var(--accent-color-02-opacity);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.privacy-level {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: row;\n\t\t\t\talign-items: center;\n\t\t\t\tmargin: 10px 0;\n\n\t\t\t\t>* {\n\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.button-container {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\tjustify-content: flex-end;\n\t\t\tmargin-top: 20px;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddNetwork_container__VdEC+`,
	"image": `AddNetwork_image__HPfxO`,
	"add-flight-plan": `AddNetwork_add-flight-plan__+oSFB`,
	"inputs": `AddNetwork_inputs__gGR3e`,
	"heading": `AddNetwork_heading__QSt6Z`,
	"errors": `AddNetwork_errors__963Zr`,
	"date-input-row": `AddNetwork_date-input-row__yoB8n`,
	"place-input-row": `AddNetwork_place-input-row__4OGTV`,
	"place-input-container": `AddNetwork_place-input-container__hSeXd`,
	"place-input": `AddNetwork_place-input__LNh5M`,
	"text-details": `AddNetwork_text-details__+Shmo`,
	"privacy-level": `AddNetwork_privacy-level__--IhF`,
	"button-container": `AddNetwork_button-container__-9w4A`
};
export default ___CSS_LOADER_EXPORT___;
